import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'
import toPageKnowledge from '../views/toPageKnowledge.vue'
import PaymentManagement from '../views/tabpane/PaymentManagement.vue'
import EarningReport from '../views/tabpane/EarningReport.vue'
import RadarStudentsAttendance from '../views/RadarStudentsAttendance.vue'
import RadarClassAttendance from '../views/RadarClassAttendance.vue'
import AshoreRanking from '../views/AshoreRanking.vue'
import LearnBigData from '../views/LearnBigData.vue'
import ExplosiveClassroom from '../views/ExplosiveClassroom.vue'
import LookQuestionnaire from '../views/CreateSurvey/LookQuestionnaire.vue'
import MarkQuestionnaire from '../views/CreateSurvey/MarkQuestionnaire.vue'
import MarkExampapers from '../views/Exam/MarkExampapers.vue'
import InformationStudentListNew from '../views/tabpane/InformationStudentListNew.vue'
import CourseConversionStudentListNew from '../views/tabpane/CourseConversionStudentListNew.vue'
import AssignAccessStudentList from '../views/tabpane/AssignAccessStudentList.vue'
import DistributionWeightStudentList from '../views/tabpane/DistributionWeightStudentList.vue'
import PeriodicReportStudentList from '@/views/tabpane/PeriodicReportStudentList.vue';
import PersonalHonorReport from '../views/PersonalHonorReport.vue'
import InformationImprovementTotalPay from '../views/tabpane/InformationImprovementTotalPay.vue'

import store from '../store/index'
Vue.use(VueRouter)

const routes = [
  {
    path: '/toPageKnowledge',
    name: 'toPageKnowledge',
    // 公用页面路由，通过themenuid和userdingid参数实现钉钉登录并打开指定菜单
    component: toPageKnowledge,
  },
  {
    path: '/PaymentManagement',
    name: 'PaymentManagement',
    // 引入
    component: PaymentManagement,
  },
  {
    path: '/EarningReport',
    name: 'EarningReport',
    // 引入
    component: EarningReport,
  },
  {
    path: '/RadarStudentsAttendance',
    name: 'RadarStudentsAttendance',
    // 引入
    component: RadarStudentsAttendance,
  },
  {
    path: '/RadarClassAttendance',
    name: 'RadarClassAttendance',
    // 引入
    component: RadarClassAttendance,
  },
  {
    path: '/AshoreRanking',
    name: 'AshoreRanking',
    // 引入
    component: AshoreRanking,
  },
  {
    path: '/LearnBigData',
    name: 'LearnBigData',
    // 引入
    component: LearnBigData,
  },
  {
    path: '/ExplosiveClassroom',
    name: 'ExplosiveClassroom',
    // 引入
    component: ExplosiveClassroom,
  },
  {
    path: '/LookQuestionnaire',
    name: 'LookQuestionnaire',
    // 引入问卷查阅结果
    component: LookQuestionnaire,
  },
  {
    path: '/MarkQuestionnaire',
    name: 'MarkQuestionnaire',
    // 引入问卷批阅
    component: MarkQuestionnaire,
  },
  {
    path: '/MarkExampapers',
    name: 'MarkExampapers',
    // 引入评阅试卷
    component: MarkExampapers,
  },
  {
    path: '/InformationStudentListNew',
    name: 'InformationStudentListNew',
    component: InformationStudentListNew,
  },
  {
    path: '/PeriodicReportStudentList',
    name: 'PeriodicReportStudentList',
    component: PeriodicReportStudentList,
  },
  {
    path: '/AssignAccessStudentList',
    name: 'AssignAccessStudentList',
    component: AssignAccessStudentList,
  },
  {
    path: '/CourseConversionStudentListNew',
    name: 'CourseConversionStudentListNew',
    component: CourseConversionStudentListNew,
  },
  {
    path: '/DistributionWeightStudentList',
    name: 'DistributionWeightStudentList',
    component: DistributionWeightStudentList
  },
  {
    path: '/PersonalHonorReport',
    name: 'PersonalHonorReport',
    // 引入个人荣誉榜
    component: PersonalHonorReport,
  },
  {
    path: '/InformationImprovementTotalPay',
    name: 'InformationImprovementTotalPay',
    component: InformationImprovementTotalPay
  },
  {
    path: '/*',
    name: 'Index',
    component: Index,
  },
  
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  if (store.state.saveAllConfigStorage) {
    document.title = store.state.saveAllConfigStorage.projectName;
  } else if (sessionStorage.getItem('allConfig')) {
    document.title = JSON.parse(sessionStorage.getItem('allConfig')).projectName
  }
  next()
})
export default router
